import { createContext, useContext, useEffect, useState } from 'react'
import { fetch_user_profile } from '../api/authAPI'

const UserConfigContext = createContext()

export const UserConfigProvider = ({ children }) => {
  const [configData, setConfigData] = useState(null)

  useEffect(() => {
    fetchUserConfig()
  }, [])

  const fetchUserConfig = async () => {
    if (configData) return
    const { data, message, error } = await fetch_user_profile()
    if (error) return console.error(message)
    setConfigData(data)
  }

  return (
    <UserConfigContext.Provider value={{ configData, fetchUserConfig }}>
      {children}
    </UserConfigContext.Provider>
  )
}

export const useUserConfig = () => useContext(UserConfigContext)
